// extracted by mini-css-extract-plugin
export default {"actions":"Pruebas_actions__t9pmh","empty":"Pruebas_empty__2W89f","download":"Pruebas_download__knLQn","link":"Pruebas_link__nro-h","placeholder":"Pruebas_placeholder__yVpsh"};